<template>
  <div class="start-header relative px-3">

    <div class="start-header-bg" v-bind:style="{ 'background-color': bg.color }">
      <div class="absolute-fill" style="z-index: 2; background: linear-gradient(#EDF6FC, transparent);" />
      <card-background style="z-index: 1;" :src="bg.src" @loaded="$emit('loaded-bg')" />
    </div>

    <div class="mx-auto py-6 py-sm-9 py-md-12 white--text text-shadow" style="max-width: 1264px;">
      <div class="d-lg-flex flex-row-reverse align-center">
        <outline-laptop v-if="media" class="header-laptop flex-shrink-0 mx-auto mb-6">
          <web-media
            style="aspect-ratio: 16 / 9;"
            eager max="md"
            :id="media.id"
            :alt="media.alt"
            :is-video="media.video"
          />
        </outline-laptop>

        <div class="mx-auto text-center text-lg-right">
          <h1 class="header-font text-h4 text-md-h3 text-lg-h2">
            <slot name="h1"></slot>
          </h1>
          <slot name="append-h1"></slot>
        </div>
      </div>

      <h2 v-if="$slots.h2" class="mt-6 mt-lg-12 header-font text-h6 text-md-h5 text-lg-h4 text-center">
        <slot name="h2"></slot>
      </h2>
    </div>

    <slot name="append-inner"></slot>

  </div>
</template>


<style scoped>
.start-header-bg {
  z-index: -1;
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  height: calc(100% + 68px);
  margin-top: -68px;
}

@media (min-width: 600px) {
  .start-header-bg {
    height: calc(100% + 68px + 108px);
    margin-top: calc(-68px - 108px);
  }
}

@media (min-width: 960px) {
  .start-header-bg {
    height: calc(100% + 68px + 60px);
    margin-top: calc(-68px - 60px);
  }
}

.header-laptop {
  z-index: 0;
  width: 100%;
}
@media (min-width: 600px) {
  h1, h2 {
    margin-left: auto;
    margin-right: auto;
    max-width: 600px;
  }
  .header-laptop {
    width: min(720px, max(80%, 600px));
  }
}
@media (min-width: 960px) {
  h1, h2 {
    max-width: 960px;
  }
}
@media (min-width: 1264px) {
  .header-laptop {
    width: 720px;
  }
}
</style>


<script>
import CardBackground from '@/components/CardBackground.vue';
import OutlineLaptop from '@/components/OutlineLaptop.vue';
import WebMedia from '@/components/WebMedia.vue';

export default {
  name: 'start-header',

  components: {
    CardBackground,
    OutlineLaptop,
    WebMedia
  },

  props: [ 'media', 'bg', 'to' ]
}
</script>
